import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import student_Store from "../store/student_store";
import supervisor_Store from "../store/supervisor_store";
import admin_Store from "../store/admin_store";
import course_Store from "../store/course_store";
import ExportCSV from "../functions/ExportCSV";
import AddForm_Modal from "../component/AddForm_Modal";
import YesNoAsk_Modal from "../component/YesNoAsk_Modal";
import CurrUser from "../functions/UserAuth";
import { v4 as uuidv4 } from "uuid"; // import the uuid package
import { toast } from "react-toastify";
import styles from "../css/styles.module.css";

// work on licences table
// student supervisor status for login
// displaying error while login

function Course_Page() {
  //#region stores
  // Student Store
  const student = student_Store((state) => state.student);
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor);
  // Admin Store
  const admin = admin_Store((state) => state.admin);
  // Course store
  const courses = course_Store((state) => state.courses);
  // all courses
  const getcourses = course_Store((state) => state.getCourses);
  // add course
  const addCourse = course_Store((state) => state.addCourse);
  // edit course
  const editCourse = course_Store((state) => state.editCourse);
  // delete course
  const deleteCourse = course_Store((state) => state.deleteCourse);
  //#endregion

  // //  let [selectValue, setSelectValue]= useState([])
  // function onSelect(actionId, id, setStatus, setClasss) {
  //   setStatus(actionId)
  //   let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
  //   setClasss(classvalue)
  //   putcourse({ status: actionId }, id, currentUser?.token)
  //   //   setClasss(classvalue)
  // }

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const currentUser = CurrUser(student, supervisor, admin);
  // course name input
  let [name, setName] = useState("");

  // code  input
  let [code, setCode] = useState("");

  // credit  input
  let [credit, setCredit] = useState("");

  // offer  input
  let [offer, setOffer] = useState(true);

  // preRequisite input
  let [preRequisite, setPreRequisite] = useState("");

  // course id
  let [idiiiii, setId] = useState(-1);

  // Add & Edit modal control
  const [isAdd, setIsAdd] = useState(false);

  // for holding data while search
  let [mydata, setMydata] = useState([]);

  // page for pagination
  const [page, setPage] = useState(1);
  // page for pagination
  const [perPage, setPerPage] = useState(10);

  //#endregion variables

  //#region functions

  // edit course
  const edit = (id) => {
    setId(id);
    const result = courses?.data?.find((course) => course.id === id);
    setName(result?.name);
    setCode(result?.code);
    setCredit(result?.credit);
    setPreRequisite(result?.preRequisite);
    setIsAdd(true);
  };
  // add course
  const add = (id) => {
    setId(-1);
    setName("");
    setPreRequisite("");
    setCode("");
    setCredit("");
    setIsAdd(true);
  };
  // page pagination
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  // page pagination
  const handlePageChange = (page) => {
    setPage(page);
  };
  // page pagination
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  // searching data
  function onChange(e) {
    let word = e.target.value;
    const result = courses.data.filter(
      (course) =>
        (course.name &&
          course.name.toLowerCase().includes(word.toLowerCase())) ||
        course.code.includes(word) ||
        course?.id == word
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  // CSV Export
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : courses.data;
    arr.forEach(
      (obj) =>
        (obj.created_at =
          new Date(obj?.created_at ?? "")
            ?.toLocaleString()
            ?.replace(",", "-") ?? "")
    );
    arr.forEach((obj, index) => (obj.id = index + 1));
    ExportCSV(arr, "courses");
  }

  //#endregion functions

  //#region constructor
  useEffect(() => {
    getcourses(currentUser?.token);
  }, []);

  //#endregion constructor

  //#region Datatable column

  // selectors name should be same as in the database
  const columns = [
    {
      name: "ID",
      // selector: (row) => row?.id,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px",
      id: "id",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      id: 2,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      id: 3,
      width: "100px",
    },
    {
      name: "Credit",
      selector: (row) => row.credit,
      width: "70px",
      id: 4,
    },
    {
      name: "Pre-requisite",
      selector: (row) => row.preRequisite,
      id: 5,
    },
    {
      name: "Offer",
      selector: (row) => "" + row.offer,
      id: 6,
      width: "100px",
    },
    {
      name: "Edit",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              edit(row.id);
            }}
            className="btn text-white bg-primary btn-md"
            type="button"
          >
            <i className="bi bi-pencil"></i>
          </button>
        );
      },
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              handleShow();
              setId(row.id);
            }}
            className="btn text-white bg-danger btn-md"
            type="button"
          >
            <i class="bi bi-trash-fill"></i>
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
    },
    // {
    //   name: "Status",
    //   cell: (row) => {
    //     let classs = row.status == 'Pending' ? 'warning' : row.status == 'Activated' ? 'success' : 'danger';
    //     const status = row.status
    //     return <Selector_Component classs={classs} row={row} onSelect={onSelect} status={status} />
    //   }
    //   ,
    //   ignoreRowClick: true,
    //   allowOverflow: true,

    //   // button: true,
    // },
  ];
  //#endregion table column

  const deleteItem = async () => {
    try {
      // check and validation for name existence
      const result = await deleteCourse(idiiiii);
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = "Course deleted successfully";
        toast.success(msg);
        // disappear modal
        handleClose();
        setShow(false);
        setIsAdd(false);
      }
    } catch (error) {
      const errmsg = error.response?.data?.message;
      if (!errmsg) return;
      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
  };

  //#region render
  const bodyMessage =
    "Do you really want to delete? This process cannot be undone.";

  return (
    <>
      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>
        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              add();
            }}
            className="btn text-white bg-primary btn-md col-12"
            type="button"
          >
            <i className="bi bi-plus-lg" aria-hidden="true"></i>
          </button>
        </div>
        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>

      {/* Datatable */}
      <DataTable
        title="Courses"
        columns={columns}
        data={mydata?.length > 0 ? mydata : courses.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : courses?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />

      {/* Add & Edit Modal  */}
      <AddForm_Modal
        setIsAdd={setIsAdd}
        isOpen={isAdd}
        id={idiiiii}
        addCourse={addCourse}
        editCourse={editCourse}
        token={currentUser?.token}
        name={name}
        code={code}
        credit={credit}
        preRequisite={preRequisite}
        setName={setName}
        setPreRequisite={setPreRequisite}
        setCode={setCode}
        setCredit={setCredit}
        offer={offer}
        setOffer={setOffer}
      />

      {/* Delete Modal  */}
      <YesNoAsk_Modal
        btnName={"Delete"}
        title={"Are you sure?"}
        bodyMessage={bodyMessage}
        responseMessage={"Delete"}
        variant={"danger"}
        handleClose={handleClose}
        show={show}
        submitFunc={async function () {
          deleteItem();
        }}
      />
    </>
  );
  //#endregion render
}

export default Course_Page;
